export const RepetitionType = {
    NEVER: "RepetitionType.NEVER",
    DAILY: "RepetitionType.DAILY",
    WEEKLY: "RepetitionType.WEEKLY",
    MONTHLY: "RepetitionType.MONTHLY",
    ANNUAL: "RepetitionType.ANNUAL",
    CUSTOM: "RepetitionType.CUSTOM",
};
